// extracted by mini-css-extract-plugin
export default {"header":"header_header__RmHLG","flexBox":"header_flexBox__nMPwz"};